export default __webpack_public_path__ + "static/media/ic-wetland-drainage.dae395d2.svg";